'use strict'

const SET_SAMPLE_LIST = 'SET_SAMPLE_LIST'
const CREATE_SAMPLE = 'CREATE_SAMPLE'
const UPDATE_SAMPLE = 'UPDATE_SAMPLE'
const DELETE_SAMPLES = 'DELETE_SAMPLES'

import format from 'string-format'

import api from '../../api'
import {Sample} from '../../models/Sample'

const initialState = {
	sample_list: [],
	samples: {},
}

const actions = {
	list_sample: function ({commit}, {project_id}) {
		console.debug(format("store.sample.list_sample( project_id={0} )", project_id))

		return api.sample.sample_list(project_id)
			.then(function (response) {

				const data = response.data.map((s_data) => new Sample(s_data))
				commit(SET_SAMPLE_LIST, response.data)
				return true
			})
			.catch(function (error) {
				commit(SET_SAMPLE_LIST, [])
				throw error
			})
	},

	create_sample: function ({commit}, {sample, details = true}) {
		console.debug(format(
			"store.modules.sample.create_sample(, details: {details} )",
			{details: details,}))

		return api.sample.sample_create(sample, details)
			.then(function (response) {
				commit(CREATE_SAMPLE, response.data)
			})
	},

	update_sample: function ({commit}, {sample, details = true}) {
		console.debug(format(
			"store.modules.sample.update_sample( ,details: {details} )",
			{details: details,}))

		return api.sample.sample_update(sample, details)
			.then(function (response) {
				commit(UPDATE_SAMPLE, response.data)
			})
	},

	delete_samples: function ({commit}, sample_id_list) {
		console.debug(format(
			"store.modules.sample.delete_samples( [ {0} ])",
			sample_id_list.join(', ')))

		return api.sample.samples_delete(sample_id_list)
			.then(function (response) {

				const sample_list_deleted = response.data
				commit(DELETE_SAMPLES, sample_list_deleted)

				return sample_list_deleted
			})
	},
}

const mutations = {
	[SET_SAMPLE_LIST](state, data) {
		console.debug("store.sample.mutations.SET_SAMPLE_LIST()")

		state.sample_list = data
		state.samples = Object.assign(
			{},
			...data.map((s) => ({[s.id]: s})))
	},

	[CREATE_SAMPLE](state, obj) {
		const sample_id = obj.id
		state.samples[sample_id] = obj
		state.sample_list.push(obj)
	},

	/**
	 * чтобы не заменять объект в списках
	 * state.sample_list и state.samples
	 * обновим значения полей
	 */
	[UPDATE_SAMPLE](state, obj) {
		const tgt = state.samples[obj.id]
		for (const key in tgt) {
			tgt[key] = obj[key]
		}
	},

	[DELETE_SAMPLES](state, sample_id_list) {
		for (const sample_id of sample_id_list) {
			if (sample_id in state.samples) {
				const sample = state.samples[sample_id]
				delete state.samples[sample_id]

				const sample_idx = state.sample_list.indexOf(sample)
				if (sample_idx > -1) {
					state.sample_list.splice(sample_idx, 1)
				}
			}
		}
	},

}

const getters = {
	sample_list: function (state) {
		return state.sample_list
	},

	samples: function (state) {
		return state.samples
	},

}

export default {
	namespaced: true,

	state: initialState,

	actions,
	mutations,
	getters,
}

